import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from './supportModels.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.i8r_1.f2();
}
function State$Companion$_anonymous__e2p05a() {
  return createSimpleEnumSerializer('com.crowpay.State', values());
}
var State_Alabama_instance;
var State_Alaska_instance;
var State_Arizona_instance;
var State_Arkansas_instance;
var State_California_instance;
var State_Colorado_instance;
var State_Connecticut_instance;
var State_Delaware_instance;
var State_DistrictOfColumbia_instance;
var State_Florida_instance;
var State_Georgia_instance;
var State_Hawaii_instance;
var State_Idaho_instance;
var State_Illinois_instance;
var State_Indiana_instance;
var State_Iowa_instance;
var State_Kansas_instance;
var State_Kentucky_instance;
var State_Louisiana_instance;
var State_Maine_instance;
var State_Maryland_instance;
var State_Massachusetts_instance;
var State_Michigan_instance;
var State_Minnesota_instance;
var State_Mississippi_instance;
var State_Missouri_instance;
var State_Montana_instance;
var State_Nebraska_instance;
var State_Nevada_instance;
var State_NewHampshire_instance;
var State_NewJersey_instance;
var State_NewMexico_instance;
var State_NewYork_instance;
var State_NorthCarolina_instance;
var State_NorthDakota_instance;
var State_Ohio_instance;
var State_Oklahoma_instance;
var State_Oregon_instance;
var State_Pennsylvania_instance;
var State_RhodeIsland_instance;
var State_SouthCarolina_instance;
var State_SouthDakota_instance;
var State_Tennessee_instance;
var State_Texas_instance;
var State_Utah_instance;
var State_Vermont_instance;
var State_Virginia_instance;
var State_Washington_instance;
var State_WestVirginia_instance;
var State_Wisconsin_instance;
var State_Wyoming_instance;
function values() {
  return [State_Alabama_getInstance(), State_Alaska_getInstance(), State_Arizona_getInstance(), State_Arkansas_getInstance(), State_California_getInstance(), State_Colorado_getInstance(), State_Connecticut_getInstance(), State_Delaware_getInstance(), State_DistrictOfColumbia_getInstance(), State_Florida_getInstance(), State_Georgia_getInstance(), State_Hawaii_getInstance(), State_Idaho_getInstance(), State_Illinois_getInstance(), State_Indiana_getInstance(), State_Iowa_getInstance(), State_Kansas_getInstance(), State_Kentucky_getInstance(), State_Louisiana_getInstance(), State_Maine_getInstance(), State_Maryland_getInstance(), State_Massachusetts_getInstance(), State_Michigan_getInstance(), State_Minnesota_getInstance(), State_Mississippi_getInstance(), State_Missouri_getInstance(), State_Montana_getInstance(), State_Nebraska_getInstance(), State_Nevada_getInstance(), State_NewHampshire_getInstance(), State_NewJersey_getInstance(), State_NewMexico_getInstance(), State_NewYork_getInstance(), State_NorthCarolina_getInstance(), State_NorthDakota_getInstance(), State_Ohio_getInstance(), State_Oklahoma_getInstance(), State_Oregon_getInstance(), State_Pennsylvania_getInstance(), State_RhodeIsland_getInstance(), State_SouthCarolina_getInstance(), State_SouthDakota_getInstance(), State_Tennessee_getInstance(), State_Texas_getInstance(), State_Utah_getInstance(), State_Vermont_getInstance(), State_Virginia_getInstance(), State_Washington_getInstance(), State_WestVirginia_getInstance(), State_Wisconsin_getInstance(), State_Wyoming_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.i8r_1 = lazy(tmp_0, State$Companion$_anonymous__e2p05a);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  State_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var State_entriesInitialized;
function State_initEntries() {
  if (State_entriesInitialized)
    return Unit_instance;
  State_entriesInitialized = true;
  State_Alabama_instance = State().i9b('Alabama', 0, 'Alabama', 'AL');
  State_Alaska_instance = State().i9b('Alaska', 1, 'Alaska', 'AK');
  State_Arizona_instance = State().i9b('Arizona', 2, 'Arizona', 'AZ');
  State_Arkansas_instance = State().i9b('Arkansas', 3, 'Arkansas', 'AR');
  State_California_instance = State().i9b('California', 4, 'California', 'CA');
  State_Colorado_instance = State().i9b('Colorado', 5, 'Colorado', 'CO');
  State_Connecticut_instance = State().i9b('Connecticut', 6, 'Connecticut', 'CT');
  State_Delaware_instance = State().i9b('Delaware', 7, 'Delaware', 'DE');
  State_DistrictOfColumbia_instance = State().i9b('DistrictOfColumbia', 8, 'District of Columbia', 'DC');
  State_Florida_instance = State().i9b('Florida', 9, 'Florida', 'FL');
  State_Georgia_instance = State().i9b('Georgia', 10, 'Georgia', 'GA');
  State_Hawaii_instance = State().i9b('Hawaii', 11, 'Hawaii', 'HI');
  State_Idaho_instance = State().i9b('Idaho', 12, 'Idaho', 'ID');
  State_Illinois_instance = State().i9b('Illinois', 13, 'Illinois', 'IL');
  State_Indiana_instance = State().i9b('Indiana', 14, 'Indiana', 'IN');
  State_Iowa_instance = State().i9b('Iowa', 15, 'Iowa', 'IA');
  State_Kansas_instance = State().i9b('Kansas', 16, 'Kansas', 'KS');
  State_Kentucky_instance = State().i9b('Kentucky', 17, 'Kentucky', 'KY');
  State_Louisiana_instance = State().i9b('Louisiana', 18, 'Louisiana', 'LA');
  State_Maine_instance = State().i9b('Maine', 19, 'Maine', 'ME');
  State_Maryland_instance = State().i9b('Maryland', 20, 'Maryland', 'MD');
  State_Massachusetts_instance = State().i9b('Massachusetts', 21, 'Massachusetts', 'MA');
  State_Michigan_instance = State().i9b('Michigan', 22, 'Michigan', 'MI');
  State_Minnesota_instance = State().i9b('Minnesota', 23, 'Minnesota', 'MN');
  State_Mississippi_instance = State().i9b('Mississippi', 24, 'Mississippi', 'MS');
  State_Missouri_instance = State().i9b('Missouri', 25, 'Missouri', 'MO');
  State_Montana_instance = State().i9b('Montana', 26, 'Montana', 'MT');
  State_Nebraska_instance = State().i9b('Nebraska', 27, 'Nebraska', 'NE');
  State_Nevada_instance = State().i9b('Nevada', 28, 'Nevada', 'NV');
  State_NewHampshire_instance = State().i9b('NewHampshire', 29, 'New Hampshire', 'NH');
  State_NewJersey_instance = State().i9b('NewJersey', 30, 'New Jersey', 'NJ');
  State_NewMexico_instance = State().i9b('NewMexico', 31, 'New Mexico', 'NM');
  State_NewYork_instance = State().i9b('NewYork', 32, 'NewYork', 'NY');
  State_NorthCarolina_instance = State().i9b('NorthCarolina', 33, 'North Carolina', 'NC');
  State_NorthDakota_instance = State().i9b('NorthDakota', 34, 'North Dakota', 'ND');
  State_Ohio_instance = State().i9b('Ohio', 35, 'Ohio', 'OH');
  State_Oklahoma_instance = State().i9b('Oklahoma', 36, 'Oklahoma', 'OK');
  State_Oregon_instance = State().i9b('Oregon', 37, 'Oregon', 'OR');
  State_Pennsylvania_instance = State().i9b('Pennsylvania', 38, 'Pennsylvania', 'PA');
  State_RhodeIsland_instance = State().i9b('RhodeIsland', 39, 'Rhode Island', 'RI');
  State_SouthCarolina_instance = State().i9b('SouthCarolina', 40, 'South Carolina', 'SC');
  State_SouthDakota_instance = State().i9b('SouthDakota', 41, 'South Dakota', 'SD');
  State_Tennessee_instance = State().i9b('Tennessee', 42, 'Tennessee', 'TN');
  State_Texas_instance = State().i9b('Texas', 43, 'Texas', 'TX');
  State_Utah_instance = State().i9b('Utah', 44, 'Utah', 'UT');
  State_Vermont_instance = State().i9b('Vermont', 45, 'Vermont', 'VT');
  State_Virginia_instance = State().i9b('Virginia', 46, 'Virginia', 'VA');
  State_Washington_instance = State().i9b('Washington', 47, 'Washington', 'WA');
  State_WestVirginia_instance = State().i9b('WestVirginia', 48, 'West Virginia', 'WV');
  State_Wisconsin_instance = State().i9b('Wisconsin', 49, 'Wisconsin', 'WI');
  State_Wyoming_instance = State().i9b('Wyoming', 50, 'Wyoming', 'WY');
  Companion_getInstance();
}
var $ENTRIES;
var StateClass;
function State() {
  if (StateClass === VOID) {
    class $ extends Enum() {
      static i9b(name, ordinal, display, abbreviated) {
        var $this = this.c4(name, ordinal);
        $this.g9b_1 = display;
        $this.h9b_1 = abbreviated;
        return $this;
      }
    }
    initMetadataForClass($, 'State', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    StateClass = $;
  }
  return StateClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.y8q_1.f2();
}
function LineItemState$Companion$_anonymous__m2ctp7() {
  return createSimpleEnumSerializer('com.crowpay.LineItemState', values_0());
}
var LineItemState_NotStarted_instance;
var LineItemState_InProgress_instance;
var LineItemState_KeepWorking_instance;
var LineItemState_RequestingReview_instance;
var LineItemState_InReview_instance;
var LineItemState_NotApproved_instance;
var LineItemState_Issue_instance;
var LineItemState_Disputed_instance;
var LineItemState_Resolving_instance;
var LineItemState_WorkingOnRemedy_instance;
var LineItemState_OnHold_instance;
var LineItemState_ResolveLater_instance;
var LineItemState_Complete_instance;
var LineItemState_AutoAccepted_instance;
var LineItemState_Resolved_instance;
var LineItemState_Settled_instance;
var LineItemState_ForceComplete_instance;
var LineItemState_Handled_instance;
var LineItemState_Cancelled_instance;
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.y8q_1 = lazy(tmp_0, LineItemState$Companion$_anonymous__m2ctp7);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  LineItemState_initEntries();
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
function values_0() {
  return [LineItemState_NotStarted_getInstance(), LineItemState_InProgress_getInstance(), LineItemState_KeepWorking_getInstance(), LineItemState_RequestingReview_getInstance(), LineItemState_InReview_getInstance(), LineItemState_NotApproved_getInstance(), LineItemState_Issue_getInstance(), LineItemState_Disputed_getInstance(), LineItemState_Resolving_getInstance(), LineItemState_WorkingOnRemedy_getInstance(), LineItemState_OnHold_getInstance(), LineItemState_ResolveLater_getInstance(), LineItemState_Complete_getInstance(), LineItemState_AutoAccepted_getInstance(), LineItemState_Resolved_getInstance(), LineItemState_Settled_getInstance(), LineItemState_ForceComplete_getInstance(), LineItemState_Handled_getInstance(), LineItemState_Cancelled_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var LineItemState_entriesInitialized;
function LineItemState_initEntries() {
  if (LineItemState_entriesInitialized)
    return Unit_instance;
  LineItemState_entriesInitialized = true;
  LineItemState_NotStarted_instance = LineItemState().o9b('NotStarted', 0, 'Not Started', '#626262');
  LineItemState_InProgress_instance = LineItemState().o9b('InProgress', 1, 'Working', '#f27c1c');
  LineItemState_KeepWorking_instance = LineItemState().o9b('KeepWorking', 2, 'Keep Working', '#f27c1c');
  LineItemState_RequestingReview_instance = LineItemState().o9b('RequestingReview', 3, 'Sign-Off', '#7b22ed', 1);
  LineItemState_InReview_instance = LineItemState().o9b('InReview', 4, 'In Review', '#7b22ed', 1);
  LineItemState_NotApproved_instance = LineItemState().o9b('NotApproved', 5, 'Not Ready', '#545454', 2);
  LineItemState_Issue_instance = LineItemState().o9b('Issue', 6, 'Issue', '#F2BA1C', 3);
  LineItemState_Disputed_instance = LineItemState().o9b('Disputed', 7, 'Dispute', '#f72700', 4);
  LineItemState_Resolving_instance = LineItemState().o9b('Resolving', 8, 'Resolving', '#7b22ed', 1);
  LineItemState_WorkingOnRemedy_instance = LineItemState().o9b('WorkingOnRemedy', 9, 'Fixing', '#f27c1c');
  LineItemState_OnHold_instance = LineItemState().o9b('OnHold', 10, 'On Hold', '#626262');
  LineItemState_ResolveLater_instance = LineItemState().o9b('ResolveLater', 11, 'Unresolved', '#545454');
  LineItemState_Complete_instance = LineItemState().o9b('Complete', 12, 'Approved', '#00ab4d');
  LineItemState_AutoAccepted_instance = LineItemState().o9b('AutoAccepted', 13, 'Accepted', '#00ab4d');
  LineItemState_Resolved_instance = LineItemState().o9b('Resolved', 14, 'Resolved', '#00ab4d');
  LineItemState_Settled_instance = LineItemState().o9b('Settled', 15, 'Settled', '#00ab4d');
  LineItemState_ForceComplete_instance = LineItemState().o9b('ForceComplete', 16, 'Force Complete', '#00ab4d');
  LineItemState_Handled_instance = LineItemState().o9b('Handled', 17, 'Handled', '#00ab4d');
  LineItemState_Cancelled_instance = LineItemState().o9b('Cancelled', 18, 'Removed', '#626262');
  Companion_getInstance_0();
}
var $ENTRIES_0;
var LineItemStateClass;
function LineItemState() {
  if (LineItemStateClass === VOID) {
    class $ extends Enum() {
      static o9b(name, ordinal, displayName, displayColor, priority) {
        priority = priority === VOID ? 0 : priority;
        var $this = this.c4(name, ordinal);
        $this.l9b_1 = displayName;
        $this.m9b_1 = displayColor;
        $this.n9b_1 = priority;
        return $this;
      }
      e90() {
        return this.l9b_1;
      }
      f90() {
        return this.m9b_1;
      }
      g90() {
        return this.n9b_1;
      }
      toString() {
        return this.l9b_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'LineItemState', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_0});
    LineItemStateClass = $;
  }
  return LineItemStateClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.w8q_1.f2();
}
function ReportType$Companion$_anonymous__iyzqtd() {
  return createSimpleEnumSerializer('com.crowpay.ReportType', values_1());
}
var ReportType_Daily_instance;
var ReportType_Weekly_instance;
var ReportType_Monthly_instance;
function values_1() {
  return [ReportType_Daily_getInstance(), ReportType_Weekly_getInstance(), ReportType_Monthly_getInstance()];
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.w8q_1 = lazy(tmp_0, ReportType$Companion$_anonymous__iyzqtd);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  ReportType_initEntries();
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var ReportType_entriesInitialized;
function ReportType_initEntries() {
  if (ReportType_entriesInitialized)
    return Unit_instance;
  ReportType_entriesInitialized = true;
  ReportType_Daily_instance = ReportType().r9b('Daily', 0);
  ReportType_Weekly_instance = ReportType().r9b('Weekly', 1);
  ReportType_Monthly_instance = ReportType().r9b('Monthly', 2);
  Companion_getInstance_1();
}
var ReportTypeClass;
function ReportType() {
  if (ReportTypeClass === VOID) {
    class $ extends Enum() {
      static r9b(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'ReportType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    ReportTypeClass = $;
  }
  return ReportTypeClass;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.c8r_1.f2();
}
function ProjectState$Companion$_anonymous__x3621() {
  return createSimpleEnumSerializer('com.crowpay.ProjectState', values_2());
}
var ProjectState_Creating_instance;
var ProjectState_Invited_instance;
var ProjectState_WaitingApproval_instance;
var ProjectState_Accepted_instance;
var ProjectState_AwaitingFunding_instance;
var ProjectState_TransferringFunds_instance;
var ProjectState_PendingStart_instance;
var ProjectState_InProgress_instance;
var ProjectState_Disputed_instance;
var ProjectState_PreSubstantialCompletion_instance;
var ProjectState_SubstantialCompletion_instance;
var ProjectState_RequestingComplete_instance;
var ProjectState_Locked_instance;
var ProjectState_Complete_instance;
var ProjectState_Warranty_instance;
var ProjectState_Terminated_instance;
var ProjectState_Cancelled_instance;
var ProjectState_Abandoned_instance;
function values_2() {
  return [ProjectState_Creating_getInstance(), ProjectState_Invited_getInstance(), ProjectState_WaitingApproval_getInstance(), ProjectState_Accepted_getInstance(), ProjectState_AwaitingFunding_getInstance(), ProjectState_TransferringFunds_getInstance(), ProjectState_PendingStart_getInstance(), ProjectState_InProgress_getInstance(), ProjectState_Disputed_getInstance(), ProjectState_PreSubstantialCompletion_getInstance(), ProjectState_SubstantialCompletion_getInstance(), ProjectState_RequestingComplete_getInstance(), ProjectState_Locked_getInstance(), ProjectState_Complete_getInstance(), ProjectState_Warranty_getInstance(), ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()];
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_2());
  return $ENTRIES_1;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.c8r_1 = lazy(tmp_0, ProjectState$Companion$_anonymous__x3621);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  ProjectState_initEntries();
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var ProjectState_entriesInitialized;
function ProjectState_initEntries() {
  if (ProjectState_entriesInitialized)
    return Unit_instance;
  ProjectState_entriesInitialized = true;
  ProjectState_Creating_instance = ProjectState().x9b('Creating', 0, 'Creating', '#8b3dff');
  ProjectState_Invited_instance = ProjectState().x9b('Invited', 1, 'Invited', '#8b3dff');
  ProjectState_WaitingApproval_instance = ProjectState().x9b('WaitingApproval', 2, 'Pending Award', '#8b3dff');
  ProjectState_Accepted_instance = ProjectState().x9b('Accepted', 3, 'Awarded', '#8b3dff');
  ProjectState_AwaitingFunding_instance = ProjectState().x9b('AwaitingFunding', 4, 'Funds Requested', '#8b3dff');
  ProjectState_TransferringFunds_instance = ProjectState().x9b('TransferringFunds', 5, 'Processing Funds', '#8b3dff');
  ProjectState_PendingStart_instance = ProjectState().x9b('PendingStart', 6, 'Pending Start', '#f27c1c');
  ProjectState_InProgress_instance = ProjectState().x9b('InProgress', 7, 'In Progress', '#f27c1c');
  ProjectState_Disputed_instance = ProjectState().x9b('Disputed', 8, 'Disputed', '#f72700', 3);
  ProjectState_PreSubstantialCompletion_instance = ProjectState().x9b('PreSubstantialCompletion', 9, 'Substantial completion', '#f27c1c', 2);
  ProjectState_SubstantialCompletion_instance = ProjectState().x9b('SubstantialCompletion', 10, 'Substantial completion', '#f27c1c', 2);
  ProjectState_RequestingComplete_instance = ProjectState().x9b('RequestingComplete', 11, 'Pending Complete', '#f27c1c', 2);
  ProjectState_Locked_instance = ProjectState().x9b('Locked', 12, 'Locked', '#f72700', 4);
  ProjectState_Complete_instance = ProjectState().x9b('Complete', 13, 'Complete', '#00ab4d');
  ProjectState_Warranty_instance = ProjectState().x9b('Warranty', 14, 'Warranty', '#50c685');
  ProjectState_Terminated_instance = ProjectState().x9b('Terminated', 15, 'Terminated', '#f72700');
  ProjectState_Cancelled_instance = ProjectState().x9b('Cancelled', 16, 'Cancelled', '#f72700');
  ProjectState_Abandoned_instance = ProjectState().x9b('Abandoned', 17, 'Abandoned', '#f72700');
  Companion_getInstance_2();
}
var $ENTRIES_1;
var ProjectStateClass;
function ProjectState() {
  if (ProjectStateClass === VOID) {
    class $ extends Enum() {
      static x9b(name, ordinal, displayName, displayColor, priority) {
        priority = priority === VOID ? 0 : priority;
        var $this = this.c4(name, ordinal);
        $this.u9b_1 = displayName;
        $this.v9b_1 = displayColor;
        $this.w9b_1 = priority;
        return $this;
      }
      e90() {
        return this.u9b_1;
      }
      f90() {
        return this.v9b_1;
      }
      g90() {
        return this.w9b_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'ProjectState', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_2});
    ProjectStateClass = $;
  }
  return ProjectStateClass;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.f8r_1.f2();
}
function ContractorStatus$Companion$_anonymous__ikchdk() {
  return createSimpleEnumSerializer('com.crowpay.ContractorStatus', values_3());
}
var ContractorStatus_Registering_instance;
var ContractorStatus_AwaitingApproval_instance;
var ContractorStatus_Approved_instance;
function values_3() {
  return [ContractorStatus_Registering_getInstance(), ContractorStatus_AwaitingApproval_getInstance(), ContractorStatus_Approved_getInstance()];
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.f8r_1 = lazy(tmp_0, ContractorStatus$Companion$_anonymous__ikchdk);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_3(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  ContractorStatus_initEntries();
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var ContractorStatus_entriesInitialized;
function ContractorStatus_initEntries() {
  if (ContractorStatus_entriesInitialized)
    return Unit_instance;
  ContractorStatus_entriesInitialized = true;
  ContractorStatus_Registering_instance = ContractorStatus().b9c('Registering', 0, 'Registering');
  ContractorStatus_AwaitingApproval_instance = ContractorStatus().b9c('AwaitingApproval', 1, 'Awaiting Approval');
  ContractorStatus_Approved_instance = ContractorStatus().b9c('Approved', 2, 'Approved');
  Companion_getInstance_3();
}
var ContractorStatusClass;
function ContractorStatus() {
  if (ContractorStatusClass === VOID) {
    class $ extends Enum() {
      static b9c(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.a9c_1 = displayName;
        return $this;
      }
      e90() {
        return this.a9c_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'ContractorStatus', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_3});
    ContractorStatusClass = $;
  }
  return ContractorStatusClass;
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.g8r_1.f2();
}
function ChangeType$Companion$_anonymous__6hdaez() {
  return createSimpleEnumSerializer('com.crowpay.ChangeType', values_4());
}
var ChangeType_New_instance;
var ChangeType_Modify_instance;
var ChangeType_Remove_instance;
function values_4() {
  return [ChangeType_New_getInstance(), ChangeType_Modify_getInstance(), ChangeType_Remove_getInstance()];
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.g8r_1 = lazy(tmp_0, ChangeType$Companion$_anonymous__6hdaez);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_4(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  ChangeType_initEntries();
  if (Companion_instance_4 === VOID)
    new (Companion_4())();
  return Companion_instance_4;
}
var ChangeType_entriesInitialized;
function ChangeType_initEntries() {
  if (ChangeType_entriesInitialized)
    return Unit_instance;
  ChangeType_entriesInitialized = true;
  ChangeType_New_instance = ChangeType().c9c('New', 0, 'New', 'New');
  ChangeType_Modify_instance = ChangeType().c9c('Modify', 1, 'Modify', 'Modified');
  ChangeType_Remove_instance = ChangeType().c9c('Remove', 2, 'Remove', 'Removed');
  Companion_getInstance_4();
}
var ChangeTypeClass;
function ChangeType() {
  if (ChangeTypeClass === VOID) {
    class $ extends Enum() {
      static c9c(name, ordinal, preTense, postTense) {
        var $this = this.c4(name, ordinal);
        $this.g95_1 = preTense;
        $this.h95_1 = postTense;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    ChangeTypeClass = $;
  }
  return ChangeTypeClass;
}
function _get_$cachedSerializer__te6jhj_5($this) {
  return $this.v8q_1.f2();
}
function LicenseType$Companion$_anonymous__vhibjo() {
  return createSimpleEnumSerializer('com.crowpay.LicenseType', values_5());
}
var LicenseType_Business_instance;
var LicenseType_Contractor_instance;
function values_5() {
  return [LicenseType_Business_getInstance(), LicenseType_Contractor_getInstance()];
}
function get_entries_2() {
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_5());
  return $ENTRIES_2;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.v8q_1 = lazy(tmp_0, LicenseType$Companion$_anonymous__vhibjo);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_5(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  LicenseType_initEntries();
  if (Companion_instance_5 === VOID)
    new (Companion_5())();
  return Companion_instance_5;
}
var LicenseType_entriesInitialized;
function LicenseType_initEntries() {
  if (LicenseType_entriesInitialized)
    return Unit_instance;
  LicenseType_entriesInitialized = true;
  LicenseType_Business_instance = LicenseType().f9c('Business', 0);
  LicenseType_Contractor_instance = LicenseType().f9c('Contractor', 1);
  Companion_getInstance_5();
}
var $ENTRIES_2;
var LicenseTypeClass;
function LicenseType() {
  if (LicenseTypeClass === VOID) {
    class $ extends Enum() {
      static f9c(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'LicenseType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    LicenseTypeClass = $;
  }
  return LicenseTypeClass;
}
var EscalationLevel_NotApproved_instance;
var EscalationLevel_Issue_instance;
var EscalationLevel_Disputed_instance;
var EscalationLevel_entriesInitialized;
function EscalationLevel_initEntries() {
  if (EscalationLevel_entriesInitialized)
    return Unit_instance;
  EscalationLevel_entriesInitialized = true;
  EscalationLevel_NotApproved_instance = EscalationLevel().g9c('NotApproved', 0, 'Not Approved', '#545454', 2);
  EscalationLevel_Issue_instance = EscalationLevel().g9c('Issue', 1, 'Issue', '#F2BA1C', 3);
  EscalationLevel_Disputed_instance = EscalationLevel().g9c('Disputed', 2, 'Disputed', '#f72700', 4);
}
var EscalationLevelClass;
function EscalationLevel() {
  if (EscalationLevelClass === VOID) {
    class $ extends Enum() {
      static g9c(name, ordinal, displayName, displayColor, priority) {
        priority = priority === VOID ? 0 : priority;
        var $this = this.c4(name, ordinal);
        $this.a8x_1 = displayName;
        $this.b8x_1 = displayColor;
        $this.c8x_1 = priority;
        return $this;
      }
      e90() {
        return this.a8x_1;
      }
      f90() {
        return this.b8x_1;
      }
      g90() {
        return this.c8x_1;
      }
      d8x() {
        var tmp;
        switch (this.b4_1) {
          case 0:
            tmp = LineItemState_NotApproved_getInstance();
            break;
          case 1:
            tmp = LineItemState_Issue_getInstance();
            break;
          case 2:
            tmp = LineItemState_Disputed_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      h9c() {
        var tmp;
        switch (this.b4_1) {
          case 0:
            tmp = IncidentState_Filed_getInstance();
            break;
          case 1:
            tmp = IncidentState_Issue_getInstance();
            break;
          case 2:
            tmp = IncidentState_Disputed_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'EscalationLevel', VOID, VOID, [HasDisplayName(), Enum()]);
    EscalationLevelClass = $;
  }
  return EscalationLevelClass;
}
function _get_$cachedSerializer__te6jhj_6($this) {
  return $this.d8r_1.f2();
}
function MemberRole$Companion$_anonymous__cexk0x() {
  return createSimpleEnumSerializer('com.crowpay.MemberRole', values_6());
}
var MemberRole_Employee_instance;
var MemberRole_Manager_instance;
var MemberRole_Admin_instance;
function values_6() {
  return [MemberRole_Employee_getInstance(), MemberRole_Manager_getInstance(), MemberRole_Admin_getInstance()];
}
function get_entries_3() {
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_6());
  return $ENTRIES_3;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.d8r_1 = lazy(tmp_0, MemberRole$Companion$_anonymous__cexk0x);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_6(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  MemberRole_initEntries();
  if (Companion_instance_6 === VOID)
    new (Companion_6())();
  return Companion_instance_6;
}
var MemberRole_entriesInitialized;
function MemberRole_initEntries() {
  if (MemberRole_entriesInitialized)
    return Unit_instance;
  MemberRole_entriesInitialized = true;
  MemberRole_Employee_instance = MemberRole().k9c('Employee', 0);
  MemberRole_Manager_instance = MemberRole().k9c('Manager', 1);
  MemberRole_Admin_instance = MemberRole().k9c('Admin', 2);
  Companion_getInstance_6();
}
var $ENTRIES_3;
var MemberRoleClass;
function MemberRole() {
  if (MemberRoleClass === VOID) {
    class $ extends Enum() {
      static k9c(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'MemberRole', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
    MemberRoleClass = $;
  }
  return MemberRoleClass;
}
function _get_$cachedSerializer__te6jhj_7($this) {
  return $this.e8r_1.f2();
}
function UserRole$Companion$_anonymous__pdvotq() {
  return createSimpleEnumSerializer('com.crowpay.UserRole', values_7());
}
var UserRole_Customer_instance;
var UserRole_Admin_instance;
var UserRole_Developer_instance;
var UserRole_SuperUser_instance;
function values_7() {
  return [UserRole_Customer_getInstance(), UserRole_Admin_getInstance(), UserRole_Developer_getInstance(), UserRole_SuperUser_getInstance()];
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.e8r_1 = lazy(tmp_0, UserRole$Companion$_anonymous__pdvotq);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_7(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  UserRole_initEntries();
  if (Companion_instance_7 === VOID)
    new (Companion_7())();
  return Companion_instance_7;
}
var UserRole_entriesInitialized;
function UserRole_initEntries() {
  if (UserRole_entriesInitialized)
    return Unit_instance;
  UserRole_entriesInitialized = true;
  UserRole_Customer_instance = UserRole().n9c('Customer', 0);
  UserRole_Admin_instance = UserRole().n9c('Admin', 1);
  UserRole_Developer_instance = UserRole().n9c('Developer', 2);
  UserRole_SuperUser_instance = UserRole().n9c('SuperUser', 3);
  Companion_getInstance_7();
}
var UserRoleClass;
function UserRole() {
  if (UserRoleClass === VOID) {
    class $ extends Enum() {
      static n9c(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'UserRole', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    UserRoleClass = $;
  }
  return UserRoleClass;
}
function _get_$cachedSerializer__te6jhj_8($this) {
  return $this.h8r_1.f2();
}
function Party$Companion$_anonymous__upzmnd() {
  return createSimpleEnumSerializer('com.crowpay.Party', values_8());
}
var Party_Contractor_instance;
var Party_Client_instance;
function values_8() {
  return [Party_Contractor_getInstance(), Party_Client_getInstance()];
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.h8r_1 = lazy(tmp_0, Party$Companion$_anonymous__upzmnd);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_8(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  Party_initEntries();
  if (Companion_instance_8 === VOID)
    new (Companion_8())();
  return Companion_instance_8;
}
var Party_entriesInitialized;
function Party_initEntries() {
  if (Party_entriesInitialized)
    return Unit_instance;
  Party_entriesInitialized = true;
  Party_Contractor_instance = Party().q9c('Contractor', 0);
  Party_Client_instance = Party().q9c('Client', 1);
  Companion_getInstance_8();
}
var PartyClass;
function Party() {
  if (PartyClass === VOID) {
    class $ extends Enum() {
      static q9c(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Party', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    PartyClass = $;
  }
  return PartyClass;
}
function _get_$cachedSerializer__te6jhj_9($this) {
  return $this.a8r_1.f2();
}
function PaymentState$Companion$_anonymous__9o3hg() {
  return createSimpleEnumSerializer('com.crowpay.PaymentState', values_9());
}
var PaymentState_AwaitingConfirmation_instance;
var PaymentState_Pending_instance;
var PaymentState_Succeeded_instance;
var PaymentState_Cancelled_instance;
var PaymentState_Failed_instance;
function values_9() {
  return [PaymentState_AwaitingConfirmation_getInstance(), PaymentState_Pending_getInstance(), PaymentState_Succeeded_getInstance(), PaymentState_Cancelled_getInstance(), PaymentState_Failed_getInstance()];
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      constructor() {
        Companion_instance_9 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.a8r_1 = lazy(tmp_0, PaymentState$Companion$_anonymous__9o3hg);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_9(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  PaymentState_initEntries();
  if (Companion_instance_9 === VOID)
    new (Companion_9())();
  return Companion_instance_9;
}
var PaymentState_entriesInitialized;
function PaymentState_initEntries() {
  if (PaymentState_entriesInitialized)
    return Unit_instance;
  PaymentState_entriesInitialized = true;
  PaymentState_AwaitingConfirmation_instance = PaymentState().v9c('AwaitingConfirmation', 0, 'Available', '#00ab4d');
  PaymentState_Pending_instance = PaymentState().v9c('Pending', 1, 'Transferring', '#f27c1c');
  PaymentState_Succeeded_instance = PaymentState().v9c('Succeeded', 2, 'Transferred', '#00ab4d');
  PaymentState_Cancelled_instance = PaymentState().v9c('Cancelled', 3, 'Cancelled', '#626262');
  PaymentState_Failed_instance = PaymentState().v9c('Failed', 4, 'Failed', '#f72700');
  Companion_getInstance_9();
}
var PaymentStateClass;
function PaymentState() {
  if (PaymentStateClass === VOID) {
    class $ extends Enum() {
      static v9c(name, ordinal, displayName, displayColor) {
        var $this = this.c4(name, ordinal);
        $this.t9c_1 = displayName;
        $this.u9c_1 = displayColor;
        return $this;
      }
      e90() {
        return this.t9c_1;
      }
      f90() {
        return this.u9c_1;
      }
      g90() {
        return 0;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'PaymentState', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_9});
    PaymentStateClass = $;
  }
  return PaymentStateClass;
}
function _get_$cachedSerializer__te6jhj_10($this) {
  return $this.z8q_1.f2();
}
function IncidentState$Companion$_anonymous__ftu40g() {
  return createSimpleEnumSerializer('com.crowpay.IncidentState', values_10());
}
var IncidentState_IssueFiled_instance;
var IncidentState_Issue_instance;
var IncidentState_Disputed_instance;
var IncidentState_Resolving_instance;
var IncidentState_WorkingOnResolution_instance;
var IncidentState_RequestingReview_instance;
var IncidentState_Resolved_instance;
var IncidentState_Settled_instance;
var IncidentState_Handled_instance;
var IncidentState_Filed_instance;
function values_10() {
  return [IncidentState_IssueFiled_getInstance(), IncidentState_Issue_getInstance(), IncidentState_Disputed_getInstance(), IncidentState_Resolving_getInstance(), IncidentState_WorkingOnResolution_getInstance(), IncidentState_RequestingReview_getInstance(), IncidentState_Resolved_getInstance(), IncidentState_Settled_getInstance(), IncidentState_Handled_getInstance(), IncidentState_Filed_getInstance()];
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      constructor() {
        Companion_instance_10 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.z8q_1 = lazy(tmp_0, IncidentState$Companion$_anonymous__ftu40g);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_10(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  IncidentState_initEntries();
  if (Companion_instance_10 === VOID)
    new (Companion_10())();
  return Companion_instance_10;
}
var IncidentState_entriesInitialized;
function IncidentState_initEntries() {
  if (IncidentState_entriesInitialized)
    return Unit_instance;
  IncidentState_entriesInitialized = true;
  IncidentState_IssueFiled_instance = IncidentState().b9d('IssueFiled', 0, 'Issue', '#F2BA1C', 2);
  IncidentState_Issue_instance = IncidentState().b9d('Issue', 1, 'Issue', '#F2BA1C', 2);
  IncidentState_Disputed_instance = IncidentState().b9d('Disputed', 2, 'Disputed', '#F72700', 3);
  IncidentState_Resolving_instance = IncidentState().b9d('Resolving', 3, 'Resolving', '#7b22ed', 3);
  IncidentState_WorkingOnResolution_instance = IncidentState().b9d('WorkingOnResolution', 4, 'Fixing', '#f27c1c');
  IncidentState_RequestingReview_instance = IncidentState().b9d('RequestingReview', 5, 'In Review', '#7b22ed', 1);
  IncidentState_Resolved_instance = IncidentState().b9d('Resolved', 6, 'Resolved', '#00ab4d');
  IncidentState_Settled_instance = IncidentState().b9d('Settled', 7, 'Settled', '#00ab4d');
  IncidentState_Handled_instance = IncidentState().b9d('Handled', 8, 'Handled', '#00ab4d');
  IncidentState_Filed_instance = IncidentState().b9d('Filed', 9, 'Reported', '#626262');
  Companion_getInstance_10();
}
var IncidentStateClass;
function IncidentState() {
  if (IncidentStateClass === VOID) {
    class $ extends Enum() {
      static b9d(name, ordinal, displayName, displayColor, priority) {
        priority = priority === VOID ? 0 : priority;
        var $this = this.c4(name, ordinal);
        $this.y9c_1 = displayName;
        $this.z9c_1 = displayColor;
        $this.a9d_1 = priority;
        return $this;
      }
      e90() {
        return this.y9c_1;
      }
      f90() {
        return this.z9c_1;
      }
      g90() {
        return this.a9d_1;
      }
      c9d() {
        return setOf([IncidentState_Filed_getInstance(), IncidentState_Handled_getInstance(), IncidentState_Resolved_getInstance(), IncidentState_Settled_getInstance()]).t1(this);
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'IncidentState', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_10});
    IncidentStateClass = $;
  }
  return IncidentStateClass;
}
function _get_$cachedSerializer__te6jhj_11($this) {
  return $this.b8r_1.f2();
}
function PreferredTitle$Companion$_anonymous__1urlvc() {
  return createSimpleEnumSerializer('com.crowpay.PreferredTitle', values_11());
}
var PreferredTitle_Contractor_instance;
var PreferredTitle_Provider_instance;
var PreferredTitle_Vendor_instance;
var PreferredTitle_Agency_instance;
function values_11() {
  return [PreferredTitle_Contractor_getInstance(), PreferredTitle_Provider_getInstance(), PreferredTitle_Vendor_getInstance(), PreferredTitle_Agency_getInstance()];
}
function get_entries_4() {
  if ($ENTRIES_4 == null)
    $ENTRIES_4 = enumEntries(values_11());
  return $ENTRIES_4;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      constructor() {
        Companion_instance_11 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.b8r_1 = lazy(tmp_0, PreferredTitle$Companion$_anonymous__1urlvc);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_11(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  PreferredTitle_initEntries();
  if (Companion_instance_11 === VOID)
    new (Companion_11())();
  return Companion_instance_11;
}
var PreferredTitle_entriesInitialized;
function PreferredTitle_initEntries() {
  if (PreferredTitle_entriesInitialized)
    return Unit_instance;
  PreferredTitle_entriesInitialized = true;
  PreferredTitle_Contractor_instance = PreferredTitle().f9d('Contractor', 0);
  PreferredTitle_Provider_instance = PreferredTitle().f9d('Provider', 1);
  PreferredTitle_Vendor_instance = PreferredTitle().f9d('Vendor', 2);
  PreferredTitle_Agency_instance = PreferredTitle().f9d('Agency', 3);
  Companion_getInstance_11();
}
var $ENTRIES_4;
var PreferredTitleClass;
function PreferredTitle() {
  if (PreferredTitleClass === VOID) {
    class $ extends Enum() {
      static f9d(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'PreferredTitle', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
    PreferredTitleClass = $;
  }
  return PreferredTitleClass;
}
function _get_$cachedSerializer__te6jhj_12($this) {
  return $this.x8q_1.f2();
}
function LineItemResolutionType$Companion$_anonymous__c8zo76() {
  return createSimpleEnumSerializer('com.crowpay.LineItemResolutionType', values_12());
}
var LineItemResolutionType_Cancelled_instance;
var LineItemResolutionType_Completed_instance;
function values_12() {
  return [LineItemResolutionType_Cancelled_getInstance(), LineItemResolutionType_Completed_getInstance()];
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      constructor() {
        Companion_instance_12 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.x8q_1 = lazy(tmp_0, LineItemResolutionType$Companion$_anonymous__c8zo76);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_12(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  LineItemResolutionType_initEntries();
  if (Companion_instance_12 === VOID)
    new (Companion_12())();
  return Companion_instance_12;
}
var LineItemResolutionType_entriesInitialized;
function LineItemResolutionType_initEntries() {
  if (LineItemResolutionType_entriesInitialized)
    return Unit_instance;
  LineItemResolutionType_entriesInitialized = true;
  LineItemResolutionType_Cancelled_instance = LineItemResolutionType().i9d('Cancelled', 0);
  LineItemResolutionType_Completed_instance = LineItemResolutionType().i9d('Completed', 1);
  Companion_getInstance_12();
}
var LineItemResolutionTypeClass;
function LineItemResolutionType() {
  if (LineItemResolutionTypeClass === VOID) {
    class $ extends Enum() {
      static i9d(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'LineItemResolutionType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_12});
    LineItemResolutionTypeClass = $;
  }
  return LineItemResolutionTypeClass;
}
function State_Alabama_getInstance() {
  State_initEntries();
  return State_Alabama_instance;
}
function State_Alaska_getInstance() {
  State_initEntries();
  return State_Alaska_instance;
}
function State_Arizona_getInstance() {
  State_initEntries();
  return State_Arizona_instance;
}
function State_Arkansas_getInstance() {
  State_initEntries();
  return State_Arkansas_instance;
}
function State_California_getInstance() {
  State_initEntries();
  return State_California_instance;
}
function State_Colorado_getInstance() {
  State_initEntries();
  return State_Colorado_instance;
}
function State_Connecticut_getInstance() {
  State_initEntries();
  return State_Connecticut_instance;
}
function State_Delaware_getInstance() {
  State_initEntries();
  return State_Delaware_instance;
}
function State_DistrictOfColumbia_getInstance() {
  State_initEntries();
  return State_DistrictOfColumbia_instance;
}
function State_Florida_getInstance() {
  State_initEntries();
  return State_Florida_instance;
}
function State_Georgia_getInstance() {
  State_initEntries();
  return State_Georgia_instance;
}
function State_Hawaii_getInstance() {
  State_initEntries();
  return State_Hawaii_instance;
}
function State_Idaho_getInstance() {
  State_initEntries();
  return State_Idaho_instance;
}
function State_Illinois_getInstance() {
  State_initEntries();
  return State_Illinois_instance;
}
function State_Indiana_getInstance() {
  State_initEntries();
  return State_Indiana_instance;
}
function State_Iowa_getInstance() {
  State_initEntries();
  return State_Iowa_instance;
}
function State_Kansas_getInstance() {
  State_initEntries();
  return State_Kansas_instance;
}
function State_Kentucky_getInstance() {
  State_initEntries();
  return State_Kentucky_instance;
}
function State_Louisiana_getInstance() {
  State_initEntries();
  return State_Louisiana_instance;
}
function State_Maine_getInstance() {
  State_initEntries();
  return State_Maine_instance;
}
function State_Maryland_getInstance() {
  State_initEntries();
  return State_Maryland_instance;
}
function State_Massachusetts_getInstance() {
  State_initEntries();
  return State_Massachusetts_instance;
}
function State_Michigan_getInstance() {
  State_initEntries();
  return State_Michigan_instance;
}
function State_Minnesota_getInstance() {
  State_initEntries();
  return State_Minnesota_instance;
}
function State_Mississippi_getInstance() {
  State_initEntries();
  return State_Mississippi_instance;
}
function State_Missouri_getInstance() {
  State_initEntries();
  return State_Missouri_instance;
}
function State_Montana_getInstance() {
  State_initEntries();
  return State_Montana_instance;
}
function State_Nebraska_getInstance() {
  State_initEntries();
  return State_Nebraska_instance;
}
function State_Nevada_getInstance() {
  State_initEntries();
  return State_Nevada_instance;
}
function State_NewHampshire_getInstance() {
  State_initEntries();
  return State_NewHampshire_instance;
}
function State_NewJersey_getInstance() {
  State_initEntries();
  return State_NewJersey_instance;
}
function State_NewMexico_getInstance() {
  State_initEntries();
  return State_NewMexico_instance;
}
function State_NewYork_getInstance() {
  State_initEntries();
  return State_NewYork_instance;
}
function State_NorthCarolina_getInstance() {
  State_initEntries();
  return State_NorthCarolina_instance;
}
function State_NorthDakota_getInstance() {
  State_initEntries();
  return State_NorthDakota_instance;
}
function State_Ohio_getInstance() {
  State_initEntries();
  return State_Ohio_instance;
}
function State_Oklahoma_getInstance() {
  State_initEntries();
  return State_Oklahoma_instance;
}
function State_Oregon_getInstance() {
  State_initEntries();
  return State_Oregon_instance;
}
function State_Pennsylvania_getInstance() {
  State_initEntries();
  return State_Pennsylvania_instance;
}
function State_RhodeIsland_getInstance() {
  State_initEntries();
  return State_RhodeIsland_instance;
}
function State_SouthCarolina_getInstance() {
  State_initEntries();
  return State_SouthCarolina_instance;
}
function State_SouthDakota_getInstance() {
  State_initEntries();
  return State_SouthDakota_instance;
}
function State_Tennessee_getInstance() {
  State_initEntries();
  return State_Tennessee_instance;
}
function State_Texas_getInstance() {
  State_initEntries();
  return State_Texas_instance;
}
function State_Utah_getInstance() {
  State_initEntries();
  return State_Utah_instance;
}
function State_Vermont_getInstance() {
  State_initEntries();
  return State_Vermont_instance;
}
function State_Virginia_getInstance() {
  State_initEntries();
  return State_Virginia_instance;
}
function State_Washington_getInstance() {
  State_initEntries();
  return State_Washington_instance;
}
function State_WestVirginia_getInstance() {
  State_initEntries();
  return State_WestVirginia_instance;
}
function State_Wisconsin_getInstance() {
  State_initEntries();
  return State_Wisconsin_instance;
}
function State_Wyoming_getInstance() {
  State_initEntries();
  return State_Wyoming_instance;
}
function LineItemState_NotStarted_getInstance() {
  LineItemState_initEntries();
  return LineItemState_NotStarted_instance;
}
function LineItemState_InProgress_getInstance() {
  LineItemState_initEntries();
  return LineItemState_InProgress_instance;
}
function LineItemState_KeepWorking_getInstance() {
  LineItemState_initEntries();
  return LineItemState_KeepWorking_instance;
}
function LineItemState_RequestingReview_getInstance() {
  LineItemState_initEntries();
  return LineItemState_RequestingReview_instance;
}
function LineItemState_InReview_getInstance() {
  LineItemState_initEntries();
  return LineItemState_InReview_instance;
}
function LineItemState_NotApproved_getInstance() {
  LineItemState_initEntries();
  return LineItemState_NotApproved_instance;
}
function LineItemState_Issue_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Issue_instance;
}
function LineItemState_Disputed_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Disputed_instance;
}
function LineItemState_Resolving_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Resolving_instance;
}
function LineItemState_WorkingOnRemedy_getInstance() {
  LineItemState_initEntries();
  return LineItemState_WorkingOnRemedy_instance;
}
function LineItemState_OnHold_getInstance() {
  LineItemState_initEntries();
  return LineItemState_OnHold_instance;
}
function LineItemState_ResolveLater_getInstance() {
  LineItemState_initEntries();
  return LineItemState_ResolveLater_instance;
}
function LineItemState_Complete_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Complete_instance;
}
function LineItemState_AutoAccepted_getInstance() {
  LineItemState_initEntries();
  return LineItemState_AutoAccepted_instance;
}
function LineItemState_Resolved_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Resolved_instance;
}
function LineItemState_Settled_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Settled_instance;
}
function LineItemState_ForceComplete_getInstance() {
  LineItemState_initEntries();
  return LineItemState_ForceComplete_instance;
}
function LineItemState_Handled_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Handled_instance;
}
function LineItemState_Cancelled_getInstance() {
  LineItemState_initEntries();
  return LineItemState_Cancelled_instance;
}
function ReportType_Daily_getInstance() {
  ReportType_initEntries();
  return ReportType_Daily_instance;
}
function ReportType_Weekly_getInstance() {
  ReportType_initEntries();
  return ReportType_Weekly_instance;
}
function ReportType_Monthly_getInstance() {
  ReportType_initEntries();
  return ReportType_Monthly_instance;
}
function ProjectState_Creating_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Creating_instance;
}
function ProjectState_Invited_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Invited_instance;
}
function ProjectState_WaitingApproval_getInstance() {
  ProjectState_initEntries();
  return ProjectState_WaitingApproval_instance;
}
function ProjectState_Accepted_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Accepted_instance;
}
function ProjectState_AwaitingFunding_getInstance() {
  ProjectState_initEntries();
  return ProjectState_AwaitingFunding_instance;
}
function ProjectState_TransferringFunds_getInstance() {
  ProjectState_initEntries();
  return ProjectState_TransferringFunds_instance;
}
function ProjectState_PendingStart_getInstance() {
  ProjectState_initEntries();
  return ProjectState_PendingStart_instance;
}
function ProjectState_InProgress_getInstance() {
  ProjectState_initEntries();
  return ProjectState_InProgress_instance;
}
function ProjectState_Disputed_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Disputed_instance;
}
function ProjectState_PreSubstantialCompletion_getInstance() {
  ProjectState_initEntries();
  return ProjectState_PreSubstantialCompletion_instance;
}
function ProjectState_SubstantialCompletion_getInstance() {
  ProjectState_initEntries();
  return ProjectState_SubstantialCompletion_instance;
}
function ProjectState_RequestingComplete_getInstance() {
  ProjectState_initEntries();
  return ProjectState_RequestingComplete_instance;
}
function ProjectState_Locked_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Locked_instance;
}
function ProjectState_Complete_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Complete_instance;
}
function ProjectState_Warranty_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Warranty_instance;
}
function ProjectState_Terminated_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Terminated_instance;
}
function ProjectState_Cancelled_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Cancelled_instance;
}
function ProjectState_Abandoned_getInstance() {
  ProjectState_initEntries();
  return ProjectState_Abandoned_instance;
}
function ContractorStatus_Registering_getInstance() {
  ContractorStatus_initEntries();
  return ContractorStatus_Registering_instance;
}
function ContractorStatus_AwaitingApproval_getInstance() {
  ContractorStatus_initEntries();
  return ContractorStatus_AwaitingApproval_instance;
}
function ContractorStatus_Approved_getInstance() {
  ContractorStatus_initEntries();
  return ContractorStatus_Approved_instance;
}
function ChangeType_New_getInstance() {
  ChangeType_initEntries();
  return ChangeType_New_instance;
}
function ChangeType_Modify_getInstance() {
  ChangeType_initEntries();
  return ChangeType_Modify_instance;
}
function ChangeType_Remove_getInstance() {
  ChangeType_initEntries();
  return ChangeType_Remove_instance;
}
function LicenseType_Business_getInstance() {
  LicenseType_initEntries();
  return LicenseType_Business_instance;
}
function LicenseType_Contractor_getInstance() {
  LicenseType_initEntries();
  return LicenseType_Contractor_instance;
}
function EscalationLevel_NotApproved_getInstance() {
  EscalationLevel_initEntries();
  return EscalationLevel_NotApproved_instance;
}
function EscalationLevel_Issue_getInstance() {
  EscalationLevel_initEntries();
  return EscalationLevel_Issue_instance;
}
function EscalationLevel_Disputed_getInstance() {
  EscalationLevel_initEntries();
  return EscalationLevel_Disputed_instance;
}
function MemberRole_Employee_getInstance() {
  MemberRole_initEntries();
  return MemberRole_Employee_instance;
}
function MemberRole_Manager_getInstance() {
  MemberRole_initEntries();
  return MemberRole_Manager_instance;
}
function MemberRole_Admin_getInstance() {
  MemberRole_initEntries();
  return MemberRole_Admin_instance;
}
function UserRole_Customer_getInstance() {
  UserRole_initEntries();
  return UserRole_Customer_instance;
}
function UserRole_Admin_getInstance() {
  UserRole_initEntries();
  return UserRole_Admin_instance;
}
function UserRole_Developer_getInstance() {
  UserRole_initEntries();
  return UserRole_Developer_instance;
}
function UserRole_SuperUser_getInstance() {
  UserRole_initEntries();
  return UserRole_SuperUser_instance;
}
function Party_Contractor_getInstance() {
  Party_initEntries();
  return Party_Contractor_instance;
}
function Party_Client_getInstance() {
  Party_initEntries();
  return Party_Client_instance;
}
function PaymentState_AwaitingConfirmation_getInstance() {
  PaymentState_initEntries();
  return PaymentState_AwaitingConfirmation_instance;
}
function PaymentState_Pending_getInstance() {
  PaymentState_initEntries();
  return PaymentState_Pending_instance;
}
function PaymentState_Succeeded_getInstance() {
  PaymentState_initEntries();
  return PaymentState_Succeeded_instance;
}
function PaymentState_Cancelled_getInstance() {
  PaymentState_initEntries();
  return PaymentState_Cancelled_instance;
}
function PaymentState_Failed_getInstance() {
  PaymentState_initEntries();
  return PaymentState_Failed_instance;
}
function IncidentState_IssueFiled_getInstance() {
  IncidentState_initEntries();
  return IncidentState_IssueFiled_instance;
}
function IncidentState_Issue_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Issue_instance;
}
function IncidentState_Disputed_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Disputed_instance;
}
function IncidentState_Resolving_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Resolving_instance;
}
function IncidentState_WorkingOnResolution_getInstance() {
  IncidentState_initEntries();
  return IncidentState_WorkingOnResolution_instance;
}
function IncidentState_RequestingReview_getInstance() {
  IncidentState_initEntries();
  return IncidentState_RequestingReview_instance;
}
function IncidentState_Resolved_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Resolved_instance;
}
function IncidentState_Settled_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Settled_instance;
}
function IncidentState_Handled_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Handled_instance;
}
function IncidentState_Filed_getInstance() {
  IncidentState_initEntries();
  return IncidentState_Filed_instance;
}
function PreferredTitle_Contractor_getInstance() {
  PreferredTitle_initEntries();
  return PreferredTitle_Contractor_instance;
}
function PreferredTitle_Provider_getInstance() {
  PreferredTitle_initEntries();
  return PreferredTitle_Provider_instance;
}
function PreferredTitle_Vendor_getInstance() {
  PreferredTitle_initEntries();
  return PreferredTitle_Vendor_instance;
}
function PreferredTitle_Agency_getInstance() {
  PreferredTitle_initEntries();
  return PreferredTitle_Agency_instance;
}
function LineItemResolutionType_Cancelled_getInstance() {
  LineItemResolutionType_initEntries();
  return LineItemResolutionType_Cancelled_instance;
}
function LineItemResolutionType_Completed_getInstance() {
  LineItemResolutionType_initEntries();
  return LineItemResolutionType_Completed_instance;
}
//region block: exports
export {
  ContractorStatus as ContractorStatus22amkaqyvz8q1,
  IncidentState as IncidentState1cmotpowj6osp,
  get_entries_2 as get_entries2mo1k9tr8oys,
  LicenseType as LicenseType3s47gtt1wni19,
  get_entries_0 as get_entries3ali93lr48zte,
  LineItemState as LineItemStatehvsx7uvvfwcx,
  get_entries_3 as get_entries1ltxg9ate1zwh,
  MemberRole as MemberRole1167ovv8tjumm,
  Party as Party3ik5jb5ehc552,
  PaymentState as PaymentState2oe0svpo60h08,
  get_entries_4 as get_entries3b27rdd1an53,
  PreferredTitle as PreferredTitle2hv2nwg5p3fmp,
  get_entries_1 as get_entries3onyqwuzh1iwq,
  ProjectState as ProjectState18nmtnu5v70wt,
  ReportType as ReportType15553nfaf02up,
  get_entries as get_entriesyts36b0as1vz,
  State as State3dw676r1r3e8w,
  UserRole as UserRole18rzbkqbyt5er,
  ChangeType_Modify_getInstance as ChangeType_Modify_getInstance2320ide7eqjcd,
  ChangeType_New_getInstance as ChangeType_New_getInstance3fouji82nef8w,
  ChangeType_Remove_getInstance as ChangeType_Remove_getInstance2qh3m0yr0lh4w,
  ContractorStatus_Approved_getInstance as ContractorStatus_Approved_getInstance2o21n9qt09k9q,
  ContractorStatus_AwaitingApproval_getInstance as ContractorStatus_AwaitingApproval_getInstance3rsoledcr0pzu,
  ContractorStatus_Registering_getInstance as ContractorStatus_Registering_getInstance9wzvdghru4x2,
  EscalationLevel_Disputed_getInstance as EscalationLevel_Disputed_getInstance3pwh4crkd38ie,
  EscalationLevel_Issue_getInstance as EscalationLevel_Issue_getInstancea8pbpo27up2o,
  EscalationLevel_NotApproved_getInstance as EscalationLevel_NotApproved_getInstance172k2scjitveo,
  IncidentState_Disputed_getInstance as IncidentState_Disputed_getInstance1vczt2g7fznyr,
  IncidentState_Filed_getInstance as IncidentState_Filed_getInstanceg9puzn4wq1pv,
  IncidentState_IssueFiled_getInstance as IncidentState_IssueFiled_getInstance1pq0p85oj3ba4,
  IncidentState_Issue_getInstance as IncidentState_Issue_getInstance1n9bsrstuulg4,
  IncidentState_RequestingReview_getInstance as IncidentState_RequestingReview_getInstance9azcsnvsfz39,
  IncidentState_Resolved_getInstance as IncidentState_Resolved_getInstance22hwduixidcb1,
  IncidentState_Settled_getInstance as IncidentState_Settled_getInstance1hrwzjvkv7ot8,
  IncidentState_WorkingOnResolution_getInstance as IncidentState_WorkingOnResolution_getInstance2xzbjm5gfjniq,
  LicenseType_Business_getInstance as LicenseType_Business_getInstance28mtgpzgwrkl8,
  LicenseType_Contractor_getInstance as LicenseType_Contractor_getInstance2dtnrmu6zslm2,
  LineItemState_AutoAccepted_getInstance as LineItemState_AutoAccepted_getInstancej9rcu6sgbxxq,
  LineItemState_Cancelled_getInstance as LineItemState_Cancelled_getInstance3kcyrqker8w6h,
  LineItemState_Complete_getInstance as LineItemState_Complete_getInstancefayisedsonfg,
  LineItemState_Disputed_getInstance as LineItemState_Disputed_getInstance1ejlicwa0ud20,
  LineItemState_ForceComplete_getInstance as LineItemState_ForceComplete_getInstance30t7ooav0u0dj,
  LineItemState_Handled_getInstance as LineItemState_Handled_getInstance2darlslw9y3nm,
  LineItemState_InProgress_getInstance as LineItemState_InProgress_getInstance30c0b4tuqukui,
  LineItemState_InReview_getInstance as LineItemState_InReview_getInstancet938lsxp894e,
  LineItemState_Issue_getInstance as LineItemState_Issue_getInstancewwqrry76cukq,
  LineItemState_KeepWorking_getInstance as LineItemState_KeepWorking_getInstanceieb6rws75lm1,
  LineItemState_NotApproved_getInstance as LineItemState_NotApproved_getInstance1n0ztla6z4oyz,
  LineItemState_NotStarted_getInstance as LineItemState_NotStarted_getInstance3brd4lyoananz,
  LineItemState_OnHold_getInstance as LineItemState_OnHold_getInstance5v65qotr6ndv,
  LineItemState_RequestingReview_getInstance as LineItemState_RequestingReview_getInstance2ojeopd3nid3v,
  LineItemState_ResolveLater_getInstance as LineItemState_ResolveLater_getInstance12e6r673b4g9c,
  LineItemState_Resolved_getInstance as LineItemState_Resolved_getInstance3gyqdeh0a3lwt,
  LineItemState_Resolving_getInstance as LineItemState_Resolving_getInstancem43rd15e543j,
  LineItemState_Settled_getInstance as LineItemState_Settled_getInstance301yvu41ltgpc,
  LineItemState_WorkingOnRemedy_getInstance as LineItemState_WorkingOnRemedy_getInstanceklan96hlrfx7,
  MemberRole_Admin_getInstance as MemberRole_Admin_getInstance3iiznt2spfc6m,
  MemberRole_Employee_getInstance as MemberRole_Employee_getInstance37kv78awnpbvk,
  MemberRole_Manager_getInstance as MemberRole_Manager_getInstance3dbaoot8q9evq,
  Party_Client_getInstance as Party_Client_getInstance1cdrz74lwe2vi,
  Party_Contractor_getInstance as Party_Contractor_getInstance2xfvwqnp35yxn,
  PaymentState_AwaitingConfirmation_getInstance as PaymentState_AwaitingConfirmation_getInstance3vwisicrp8je,
  PaymentState_Succeeded_getInstance as PaymentState_Succeeded_getInstance182gjb10iikdv,
  PreferredTitle_Contractor_getInstance as PreferredTitle_Contractor_getInstance1vu9hnmofbdy6,
  ProjectState_Abandoned_getInstance as ProjectState_Abandoned_getInstance19b47j86nick,
  ProjectState_Accepted_getInstance as ProjectState_Accepted_getInstance2l1kftynf92aa,
  ProjectState_AwaitingFunding_getInstance as ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq,
  ProjectState_Cancelled_getInstance as ProjectState_Cancelled_getInstanceoirlccakusgk,
  ProjectState_Complete_getInstance as ProjectState_Complete_getInstance2ov0hpwbwxocu,
  ProjectState_Creating_getInstance as ProjectState_Creating_getInstancegu71uom71mst,
  ProjectState_Disputed_getInstance as ProjectState_Disputed_getInstance3jjamycmvlpib,
  ProjectState_InProgress_getInstance as ProjectState_InProgress_getInstance2qplvnabv8loq,
  ProjectState_Invited_getInstance as ProjectState_Invited_getInstancendchtgzjx7u0,
  ProjectState_Locked_getInstance as ProjectState_Locked_getInstance2lzy284wfpx83,
  ProjectState_PendingStart_getInstance as ProjectState_PendingStart_getInstance2dqkzmcm0blyg,
  ProjectState_PreSubstantialCompletion_getInstance as ProjectState_PreSubstantialCompletion_getInstancep7r5dsq5lipe,
  ProjectState_RequestingComplete_getInstance as ProjectState_RequestingComplete_getInstance29ba44myrjzuw,
  ProjectState_SubstantialCompletion_getInstance as ProjectState_SubstantialCompletion_getInstance3e5twdtenc1l1,
  ProjectState_Terminated_getInstance as ProjectState_Terminated_getInstancedn60ew509y4p,
  ProjectState_TransferringFunds_getInstance as ProjectState_TransferringFunds_getInstance1fufy8va5bpur,
  ProjectState_WaitingApproval_getInstance as ProjectState_WaitingApproval_getInstance1ditr18fxhnoh,
  ProjectState_Warranty_getInstance as ProjectState_Warranty_getInstance3k7ift69kuu7o,
  ReportType_Daily_getInstance as ReportType_Daily_getInstance2m8pj9vse9q1l,
  ReportType_Monthly_getInstance as ReportType_Monthly_getInstanceko04wms5avlp,
  ReportType_Weekly_getInstance as ReportType_Weekly_getInstance1l6q95r0n14c5,
  State_Utah_getInstance as State_Utah_getInstance3mij6nisrv8ix,
  UserRole_Admin_getInstance as UserRole_Admin_getInstance3u101dj1ubbhu,
  UserRole_Customer_getInstance as UserRole_Customer_getInstance1i1qwr4axl8qb,
  UserRole_SuperUser_getInstance as UserRole_SuperUser_getInstance1w3wkwxya5y4x,
  Companion_getInstance_4 as Companion_getInstance30zv25jlmpi4e,
  Companion_getInstance_3 as Companion_getInstancex9879gcn3f42,
  Companion_getInstance_10 as Companion_getInstance3oueq6ubvzdqu,
  Companion_getInstance_5 as Companion_getInstance3bhagfzu8ngcb,
  Companion_getInstance_12 as Companion_getInstance2no072znj4dgc,
  Companion_getInstance_0 as Companion_getInstance68aky2bnsasg,
  Companion_getInstance_6 as Companion_getInstance9bswgra0rac8,
  Companion_getInstance_8 as Companion_getInstance3jlmhbtm50921,
  Companion_getInstance_9 as Companion_getInstance3soflne3we53q,
  Companion_getInstance_11 as Companion_getInstance24kv293bymss5,
  Companion_getInstance_2 as Companion_getInstance1toq7c46z6qs1,
  Companion_getInstance_1 as Companion_getInstance3j1gp0u14zpbx,
  Companion_getInstance as Companion_getInstance1i8v5a4alj7fe,
  Companion_getInstance_7 as Companion_getInstance8z0585d1ojl8,
};
//endregion

//# sourceMappingURL=enums.mjs.map
